import React, { useEffect, useState } from 'react';
import { Row, Col } from 'tea-component';
import { connect, useDispatch, useHistory, useIntl } from 'umi';

import CardCommon from '@/pages/opinion/components/CardCommon';
import ChannelsLanguageChart from '../ChannelsLanguageChart';
import { getIsTodayTime } from '@/pages/opinion/utils/time';
import {
  commonBarHIcon,
  lineIcon,
  pieIcon,
} from '@/pages/opinion/constants/chart';

const chartHeightMap: any = {
  pie: 302,
  'common-bar': 340,
};

function ChannelsLanguage(props: any) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const [channelFilter, setChannelFilter] = useState('');

  const {
    userInfo,
    gameInfo,
    filter,
    languageLoading = true,
    channelLoading = true,
    handleOnClick,
  } = props;

  useEffect(() => {
    if (!userInfo || !gameInfo || !filter) return;
    let params = { ...filter };
    if (channelFilter === 'news') {
      params = getIsTodayTime(params, [1, 'month']);
    }
    dispatch({
      type: 'opinionPerformance/getOverviewChannel',
      payload: {
        ...params,
        ...gameInfo,
        user_id: userInfo.userid,
        channel_type: channelFilter,
        statistics_field: 'overview',
      },
    });
  }, [userInfo, gameInfo, filter, channelFilter]);

  useEffect(() => {
    if (!userInfo || !gameInfo || !filter) return;
    dispatch({
      type: 'opinionPerformance/getOverviewLanguage',
      payload: {
        ...filter,
        ...gameInfo,
        user_id: userInfo.userid,
        statistics_field: 'channel',
      },
    });
  }, [userInfo, gameInfo, filter]);

  // console.log('language & channel', props.language, props.channel);

  const { language, channel } = props;

  const [languageChartType, setLanguageChartType] = useState<
    'line' | 'pie' | 'common-bar'
  >('common-bar');

  const [channelChartType, setChannelChartType] = useState<
    'line' | 'pie' | 'common-bar'
  >('common-bar');

  const history = useHistory();

  return (
    <Row className="dbo-cardrow-wrap">
      <Col span={12}>
        <CardCommon
          hasTitleArrow
          handleTitleOnClick={() => history.push('/opinion/Stats/Channel')}
          title={formatMessage({ id: 'Channel' })}
          defaultOperation="common-bar"
          operations={[commonBarHIcon, lineIcon, pieIcon]}
          handleOperationsOnClick={({ symbol }) => setChannelChartType(symbol)}
          filters={[
            { text: 'All', value: '' },
            { text: 'Social Media', value: 'social' },
            { text: 'Game Store', value: 'comments' },
            { text: 'News Media', value: 'news' },
          ].map((item) => ({
            ...item,
            text: formatMessage({ id: item.text }),
          }))}
          handleFilterOnChange={(value) => setChannelFilter(value)}
          loading={channelLoading}
          empty={
            !Array.isArray(channel.mentions) || channel.mentions.length === 0
          }
          loadingHeight={300}
          emptyHeight={300}
        >
          <div className="echart-data">
            <ChannelsLanguageChart
              dataType="channel"
              data={channel}
              filter={props.filter}
              height={
                ['pie', 'common-bar'].includes(channelChartType) ? 302 : 308
              }
              type={channelChartType}
              statsDetailType="performance-channel"
              showTitle={false}
              leftTitle={formatMessage({ id: 'Mentions' })}
            ></ChannelsLanguageChart>
          </div>
        </CardCommon>
      </Col>
      <Col span={12} className="dbo-performance-height">
        <CardCommon
          hasTitleArrow
          handleTitleOnClick={() => history.push('/opinion/Stats/Language')}
          title={formatMessage({ id: 'Language' })}
          defaultOperation="common-bar"
          operations={[commonBarHIcon, lineIcon, pieIcon]}
          handleOperationsOnClick={({ symbol }) => setLanguageChartType(symbol)}
          loading={languageLoading}
          empty={
            !Array.isArray(language.mentions) || language.mentions.length === 0
          }
          loadingHeight={340}
          emptyHeight={340}
        >
          <div
            className="echart-data"
            style={{ marginTop: languageChartType === 'pie' ? 38 : 0 }}
          >
            <div className="echart-data">
              <ChannelsLanguageChart
                dataType="language"
                data={language}
                height={chartHeightMap[languageChartType] || 346}
                filter={props.filter}
                type={languageChartType}
                statsDetailType="performance-language"
                showTitle={false}
                leftTitle={formatMessage({ id: 'Mentions' })}
              ></ChannelsLanguageChart>
            </div>
          </div>
        </CardCommon>
      </Col>
    </Row>
  );
}

export default connect((state: any) => {
  const { loading, home, opinionCommon, opinionFilter, opinionPerformance } =
    state;

  return {
    userInfoLoading: loading.effects['home/getUserInfo'],
    userInfo: home.userInfo,
    gameInfo: opinionCommon.gameInfo,
    languageLoading: loading.effects['opinionPerformance/getOverviewLanguage'],
    language: opinionPerformance.language,
    channelLoading: loading.effects['opinionPerformance/getOverviewChannel'],
    channel: opinionPerformance.channel,
  };
})(ChannelsLanguage);
